app = app || {};
window.TEMPLATE_PATH = (window.TEMPLATE_PATH || '/local/templates/midea').replace(/\/?$/g, "");

// Фильтр, страница "Где купить"
app.commonfilter = {
  handlersSet: false,
  stateIsMobile: true,
  init: function init() {
    const _this = this;
    globalStorage.checkedBoxes = 0;
    globalStorage.handlers.push('commonfilter');

    app.commonfilter.resetFilterPlace();
    window.addEventListener('resize', function(){
      app.commonfilter.resetFilterPlace();
    })

    this.setHandlers();

    document.addEventListener('click', function(event){
      // Открываем/закрываем подраздел фильтра
      if (event.target.classList.contains('js-filter-opener')) {
        const parent = event.target.closest('.filter__common-item');
        parent.classList.toggle('active');
        const checkboxGroup = event.target.closest('div').querySelector('input[name="checkboxgroup"]');
        checkboxGroup.checked = !checkboxGroup.checked;
      }
    
      // Срабатывает фильтр на мобильном
      if (event.target.classList.contains('js-common-show')) {
        event.target.closest('.popup-win').querySelector('.js-popup-close').click();
        app.commonfilter.requestData();
      }
    
      // Сбрасываем настройки фильтра
      if (event.target.classList.contains('js-common-reset')) {
        const filter = document.getElementById('common_filter');
        filter.querySelectorAll('input[type="checkbox"]').forEach((el) => el.checked = false);
        globalStorage.checkedBoxes = 0;
        _this.resetFilterCheckedSpan();
        event.target.closest('.popup-win')?.querySelector('.js-popup-close').click();
        app.commonfilter.requestData();
      }
    
      // Закрываем фильтр на мобильном
      if (event.target.classList.contains('js-popup-close')) {
        $('.filter__wrapper .filter__common-row input[type="checkbox"]').each(function() {
          globalStorage.checkedBoxes += $(this).is(':checked') ? 1 : 0;
          app.commonfilter.resetFilterCheckedSpan();
        })
        if (globalStorage.checkedBoxes > 0) app.commonfilter.requestData();
      }
    })

    $('button.js-tabswitcher[data-tab="list"]').on('click', function(){
      if ($(this).hasClass('active')) return;
      // app.commonfilter.requestData();
    })

    $('#mobilefilter').on('click', function() {
      $(`#${ $(this).data('popup') }`).addClass('active').animate({opacity: 1}, 200);
      app.popupWin.scrollWindowPreventer();
    })
  },
  resetFilterCheckedSpan: function resetFilterCheckedSpan() {
    const filterCheckedSpan = document.getElementById('filter_counter');
    filterCheckedSpan.innerHTML = globalStorage.checkedBoxes;
    if (globalStorage.checkedBoxes > 0) {
      filterCheckedSpan.classList.add('show-counter');
    } else {
      filterCheckedSpan.classList.remove('show-counter');
    }
  },
  resetFilterPlace: function resetFilterPlace(forceCheck = false) {
    const commonFilter = document.getElementById('common_filter');
    if (window.innerWidth < globalStorage.windowInnerWidthBreakPoint && (forceCheck || !this.stateIsMobile)) {
      document.getElementById('popup_common_filter').appendChild(commonFilter);
      this.stateIsMobile = true;
    } else if (window.innerWidth >= globalStorage.windowInnerWidthBreakPoint && (forceCheck || this.stateIsMobile)) {
      document.getElementById('pc_common_filter').appendChild(commonFilter);
      this.stateIsMobile = false;
      const filterPopup = document.getElementById('filterpopup');
      if (!filterPopup.classList.contains('hidden-popup') && filterPopup.style.opacity === '1') {
        filterPopup.querySelector('.js-popup-close').click();
      }
    }
  },
  setHandlers: function setHandlers() {
    if (this.handlersSet) return;
    $('#common_filter input[type="checkbox"]').off('change', app.commonfilter.checkBoxFilterHandler)
    $('#common_filter input[type="checkbox"]').on('change', app.commonfilter.checkBoxFilterHandler);
    this.handlersSet = true;
  },
  resetHandlers: function resetHandlers() {
    this.handlersSet = false;
    this.resetFilterPlace(true);
    this.setHandlers();
    globalStorage.checkedBoxes = 0;
    $('.filter__wrapper .filter__common-row input[type="checkbox"]').each(function() {
      globalStorage.checkedBoxes += $(this).is(':checked') ? 1 : 0;
      app.commonfilter.resetFilterCheckedSpan();
    })
  },
  checkBoxFilterHandler: function checkBoxFilterHandler(event){
    globalStorage.checkedBoxes += $(event.target).is(':checked') ? 1 : -1;
    globalStorage.checkedBoxes = globalStorage.checkedBoxes < 0 ? 0 : globalStorage.checkedBoxes;
    app.commonfilter.resetFilterCheckedSpan();
    if (window.innerWidth >= globalStorage.windowInnerWidthBreakPoint) {
      app.commonfilter.requestData();
    }
  },
  geoSelectHandler: function geoSelectHandler() {
    app.commonfilter.requestData();
  },
  requestData: function requestData() {
    let result = $('#common_filter').serializeArray();
    result = JSON.stringify(result);

    if (typeof globalStorage.callbacks.filterApply !== 'undefined') {
      globalStorage.callbacks.filterApply(result);
    }
  },
  setDealersListData: function setDealersListData(data) {
    if (typeof data.html !== 'undefined') {
      const parsedHtml = $.parseHTML(data.html);
      $(parsedHtml).find('[data-box]').each((i, el) => {
        $(`#${ $(el).data('box') }`).html($(el).html());
      })
      globalStorage.handlersReset();
    }
    if (typeof data.map !== 'undefined') {
      app.dealer.setMarkers(data.map);
    }
  }
}

// Показ сертификатов на странице "Где купить"
app.certificate = {
  init: function init(){
    if (!globalStorage.setCertificateHandler) {
      this.setPopupOpener();
      globalStorage.setCertificateHandler = true;
    }
  },
  setPopupOpener: function setPopupOpener() {
    document.addEventListener('click', function(event) {
      if (!event.target.classList.contains('js-tt-popup') || !('app' in event.target.dataset) || event.target.dataset.app !== 'certificate') return;
      $(event.target).tooltipster('close');
      
      if (typeof globalStorage.callbacks.certClick !== 'undefined') {
        globalStorage.callbacks.certClick(event.target.dataset.cert);
      }
    })
  },
  showCertificateModal(dataArray) {
    showTemplateModal(
      dataArray,
      'certificate',
      {
        id: 'tooltippopup',
        classes: [`popup-win__cert`]
      }
    );
  }
}

// Карточки дилеров и карта
app.dealer = {
  options: {
    pinHref: "data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='8' cy='8' r='7.25' fill='%2332A3FD' stroke='white' stroke-width='1.5'/%3E%3C/svg%3E",
    pinActiveHref: "data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='8' cy='8' r='7.25' fill='%23212121' stroke='white' stroke-width='1.5'/%3E%3C/svg%3E",
    lat: 55.755814,
    lng: 37.617635,
    changeMap: true,
    ymapsApiKey: null,
  },
  inited: false,
  map: null,
  init: function init(){
    this.waitTheInit(this.initMap);

    $('button.js-tabswitcher[data-tab="map"]').on('click', function(){
      if ($(this).hasClass('active')) return;

      app.dealer.setMarkers();
      app.dealer.map.container.fitToViewport();
    })
  },
  waitTheInit: function waitTheInit(func, timeout, counter) {
    timeout = timeout || 100;
    counter = counter || 0;
    if (typeof globalStorage.ymapsApiKey !== "undefined") {
      func();
    } else if (counter < 20) {
      setTimeout(function () {
        waitTheInit(func, timeout, counter + 1);
      }, timeout);
    } else {
      func();
    }
  },
  initMap: function initMap() {
    let apikey = '';
    if (globalStorage.ymapsApiKey && app.dealer.options.ymapsApiKey) {
      return;
    } else if (globalStorage.ymapsApiKey) {
      app.dealer.options.ymapsApiKey = globalStorage.ymapsApiKey;
      apikey = 'apikey=' + globalStorage.ymapsApiKey + '&';
      $('ymaps').detach();
    }
    const ymapsScript = `https://api-maps.yandex.ru/2.1/?${ apikey }lang=ru_RU`;
    $.getScript(ymapsScript, function(){
      ymaps.ready(function () {
        (app.dealer.map = new ymaps.Map("map",
          {center: [app.dealer.options.lat, app.dealer.options.lng], zoom: 12, controls: ["zoomControl", "fullscreenControl"],},
          {searchControlProvider: "yandex#search",}
        ));
        app.dealer.lastWindowWidthWasWide = false;
        app.dealer.inited = true;
        app.dealer.setMarkers();
      }).then(() => {
        document.querySelector('.yandex-map__gray').classList.remove('yandex-map__gray');
      });
    })
  },
  setMarkers: function setMarkers(markers = globalStorage.defaultMapPoints) {
    if (typeof app.dealer.map === 'undefined' || app.dealer.map === null) return;

    if (app.dealer.map.geoObjects.getLength()) {
      app.dealer.map.geoObjects.removeAll();
    }
    if (!markers?.length) return;

    for (let item of markers) {
      let mark = new ymaps.Placemark([item.lat, item.lng], {}, {
        iconLayout: "default#imageWithContent",
        iconImageHref: app.dealer.options.pinHref,
        iconImageSize: [16, 16],
        iconImageOffset: [-8, -8],
      })
      app.dealer.map.geoObjects.add(mark);
      mark.events.add('click', function(event){
        if (typeof globalStorage.callbacks.mapClick !== 'undefined'){
          globalStorage.callbacks.mapClick(item.id);
        }
      })
      mark.events.add('mouseenter', function(){
        mark.options.set('iconImageHref', app.dealer.options.pinActiveHref);
      })
      mark.events.add('mouseleave', function(){
        mark.options.set('iconImageHref', app.dealer.options.pinHref);
      })
    }
    if (app.dealer.options.changeMap) {
      app.dealer.map.setBounds(app.dealer.map.geoObjects.getBounds());
      let zoom = app.dealer.map.getZoom();
      zoom = zoom < 9 ? 9 : (zoom > 12 ? 12 : zoom - 1);
      app.dealer.map.setZoom(zoom);
      app.dealer.options.changeMap = false;
    }
  },
  setCity: function setCity(cityName = globalStorage.defaultMapCity) {
    if (typeof app.dealer.map === 'undefined' || app.dealer.map === null) return;

    if (app.dealer.map.geoObjects.getLength()) {
      app.dealer.map.geoObjects.removeAll();
    }
    if (!cityName?.length) return;

    const city = ymaps.geocode(cityName);
    city.then(
      success => {
        app.dealer.map.setCenter(success.geoObjects.get(0).geometry.getCoordinates(), 12);
      },
      err => {
        console.log(err)
        app.dealer.map.setCenter([options.lat, options.lng], 12);
      }
    )
  },
  showShopPopup: function showShopPopup(shop) {
    (new CPopup)
      .setParams({
        parentEl: (window.innerWidth < 768 || window.innerHeight < 800) ? 'body' : '.map__shop-box',
        innerHTML: shop,
        templateName: 'map-shop',
        classes: 'map-shop__window',
        afterShow: function(id) {
          $('.map__shop-box').addClass('is-active');
          const boxH = $('.map-shop__window').height();
          const shopH = $('.map-shop__window .card-shop').outerHeight() * 2 - $('.map-shop__window .card-shop').height();
          if (shopH > boxH) {
            $('.map-shop__window .card-shop')
              .addClass(['scrollbar', 'scrollbar__vertical'])
              .css('height', boxH + 'px');
          }
          setTimeout(() => document.activeElement.blur(), 50)
        },
        afterClose: function(id) {
          $('.map__shop-box').removeClass('is-active');
        }
      })
      .showPopup();
  },
  resetLocDivScroller: function resetLocDivScroller() {
    const el = document.querySelector('.map__shops-item .card-shop__loc-container');
    if (window.innerWidth >= 769) {
      el.classList.add('scrollbar', 'scrollbar__vertical');
    } else if (window.innerWidth < 769) {
      el.classList.remove('scrollbar', 'scrollbar__vertical');
    }
    app.dealer.lastWindowWidthWasWide = window.innerWidth >= 769;
  }
}
